import { Divider, Group, Menu as MantineMenu } from '@mantine/core';
import { IconLogout, IconUser } from '@tabler/icons-react';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import useCurrentUser from '../../../../hooks/useCurrentUser';
import ProfileCardLink from '../../../core/ProfileCardLink/ProfileCardLink';

function Menu() {
  const navigate = useNavigate();
  const [currentUser] = useCurrentUser();
  // const { colorScheme, toggleColorScheme } = useMantineColorScheme({});

  const onLogOutClickHandler = useCallback(() => {
    navigate('/logout', {
      replace: true,
    });
  }, [navigate]);

  const onProfileClickHandler = useCallback(() => {
    navigate(`/users/${currentUser.idUsuario}`, {
      replace: true,
    });
  }, [navigate, currentUser.idUsuario]);

  return (
    <MantineMenu withArrow trigger="click" position="bottom-end">
      <MantineMenu.Target>
        <Group>
          <ProfileCardLink
            id={currentUser.idUsuario}
            name={currentUser.nomeCompleto}
            nameSize="sm"
            description={currentUser.departamento}
            descriptionSize="xs"
            descriptionLength={50}
            avatarSize="md"
            showAvatar
            showLink={false}
          />
        </Group>
      </MantineMenu.Target>
      <MantineMenu.Dropdown style={{ minWidth: 150 }}>
        <MantineMenu.Label>{currentUser.nomeCompleto}</MantineMenu.Label>
        <MantineMenu.Item leftSection={<IconUser size={14} />} onClick={onProfileClickHandler}>
          Perfil
        </MantineMenu.Item>
        {/* {colorScheme === 'light' ? (
          <MantineMenu.Item leftSection={<IconMoon size={16} stroke={1.5} />} onClick={toggleColorScheme}>
            Tema Escuro
          </MantineMenu.Item>
        ) : (
          <MantineMenu.Item leftSection={<IconSun size={16} stroke={1.5} />} onClick={toggleColorScheme}>
            Tema Claro
          </MantineMenu.Item>
        )} */}
        <Divider />
        <MantineMenu.Item color="red" leftSection={<IconLogout size={14} />} onClick={onLogOutClickHandler}>
          Sair
        </MantineMenu.Item>
      </MantineMenu.Dropdown>
    </MantineMenu>
  );
}

export default Menu;
